//==============================
// Header
//==============================

// down
$('.js-home-section').waypoint(function(direction) {
  var thisElement = $(this.element);
  var anchor = thisElement.attr('data-scroll-target');
  if (direction === 'down') {
    $('.header-nav a').removeClass('current');
    $('.header-nav a[href*="#' + anchor + '"]').addClass('current');
    // console.log(direction);
  }
}, {
  offset: '60%'
});


// up
$('.js-home-section').waypoint(function(direction) {
  var thisElement = $(this.element);
  var anchor = thisElement.attr('data-scroll-target');
  if (direction === 'up') {
    $('.header-nav a').removeClass('current');
    $('.header-nav a[href*="#' + anchor + '"]').addClass('current');
    // console.log(direction);
  }
}, {
  offset: '1%'
});



//==============================
// Header
//==============================

var header = $('.header');
var button = $('.header-nav-button');
var nav = $('.header-nav');

// button
button.click(function() {
  header.toggleClass('open');
  button.toggleClass('open');
  nav.toggleClass('open');
});

// scroll
function headerNotTop() {
  header.addClass('scroll');
}
function headerAtTop() {
  header.removeClass('scroll');
}
function headerScroll() {
  var scrollPos = $(window).scrollTop();
  if (scrollPos<=1) {
    headerAtTop();
  }
  else {
    headerNotTop();
  }
}

headerScroll();

$(window).scroll(function() {
  headerScroll();
});


$('.js-scroll-to-anchor').click(function() {
  header.removeClass('open');
  button.removeClass('open');
  nav.removeClass('open');
});


